<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet
        v-show="!currentItemMode"
        class="transparent-background-color fill-content-height"
      >
        <v-row dense class="ma-4">
          <v-col cols="12" sm="12" md="12" align-self="center">
            <v-row dense align="center">
              <v-spacer />
              <v-btn
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("OrderCycles.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 my-4">
          <v-data-table
            :headers="headers"
            :items="orderCycles"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.cycle_type="{ item }">
              <v-chip
                small
                label
                :color="item.cycle_type | orderCycleTypeColor"
                :text-color="item.cycle_type | orderCycleTypeTextColor"
              >
                {{ item.cycle_type | orderCycleTypeText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.viewInfo", [$t("OrderCycles.ObjectName")]) }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.editInfo", [$t("OrderCycles.ObjectName")]) }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.deleteInfo", [$t("OrderCycles.ObjectName")]) }}
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <OrderCycleDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      @mode="currentItemMode = $event"
      @save="getOrderCyclesFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('OrderCycles.ObjectName')"
      @confirm="
        deleteOrderCycle();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import OrderCycleDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import OrderCycles from "@/api/order_cycles";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    OrderCycleDetail,
    DialogDelete,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.businessSetting"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.orderCycle"),
        disabled: true,
        href: "/settings/bussiness-settings/order-cycles",
      },
    ],

    headers: () => [
      {
        text: i18n.t("OrderCycles.Fields.name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("OrderCycles.Fields.detail"),
        align: "center",
        sortable: false,
        value: "cycle_type",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    orderCycles: [],
    deleteDialog: false,
    currentItem: null,
    currentItemMode: null,
  }),

  mounted() {
    this.getOrderCyclesFromAPI();
  },

  methods: {
    getOrderCyclesFromAPI() {
      OrderCycles.fetch().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orderCycles = response.data.order_cycles;
          }
        }.bind(this)
      );
    },
    deleteOrderCycle() {
      if (this.currentItem)
        OrderCycles.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getOrderCyclesFromAPI(); // 删除成功的话刷新数据
            }
          }.bind(this)
        );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace(
            "/settings/bussiness-settings/order-cycles?id=" +
              this.currentItem.id
          );
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace(
            "/settings/bussiness-settings/order-cycles"
          );
        }
      },
    },
  },
};
</script>